import ProductTypes from './ProductTypes';

export default ProductTypes;
